<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="360"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_thirtySevenData'"
    :sqOptions="[ 38, 50]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesThirtySeven',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 94)
      } else if (value === 2) {
        this.$emit('handleProgress', 89)
      } else if (value === 3) {
        this.$emit('handleProgress', 87)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
